import { render } from "./SharedAuthConfig.vue?vue&type=template&id=22807326&scoped=true&lang=pug"
import script from "./SharedAuthConfig.vue?vue&type=script&lang=js"
export * from "./SharedAuthConfig.vue?vue&type=script&lang=js"

import "./SharedAuthConfig.vue?vue&type=style&index=0&id=22807326&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22807326"]])

export default __exports__